import { Plano } from "./plano.model";

export class ViewModelGridProcessoInstitutosLegais {
    nrCpf: string;
    nomePessoa: string;
    dtSolicitacao: Date;
    nrMatricula: string;
    dtDesligamento: Date;
    plano: Plano;
    idPessoa: number;
}